import React, { useEffect, useState } from "react";
import LoadingScreen from "../components/LoadingScreen";
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider,
  Stack,
  Breadcrumbs,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import api from "../api/axios";
import ReviewDialog from "../components/reviews/ReviewDialog";

const CustomerOrders = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openReview, setOpenReview] = useState(false);
  const [reviewCtx, setReviewCtx] = useState(null);

  const openReviewDialog = async (productId, orderId) => {
    try {
      const res = await api.get(
        `/reviews/eligibility/${productId}/${orderId}`
      );

      setReviewCtx({
        productId,
        orderId,
        mode: res.data.mode,
        reviewId: res.data.reviewId,
      });

      setOpenReview(true);
    } catch {
      alert("Unable to open review");
    }
  };

  useEffect(() => {
    if (!user?.username) return;

    api
      .get(`/orders/customer/${user.username}`)
      .then((res) => setOrders(res.data.orders || []))
      .catch(() => setOrders([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Box sx={{ maxWidth: 700, mx: "auto", mt: 6 }}>
        <LoadingScreen message="Loading orders..." />
      </Box>
    );
  }

  if (orders.length === 0) {
    return (
      <Box sx={{ maxWidth: 700, mx: "auto", mt: 6 }}>
        <Typography>No orders found</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 900, mx: "auto", mt: 4 }}>
      {/* Breadcrumb Navigation */}
      <Box sx={{ mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            underline="hover"
            color="inherit"
            href="/customer/dashboard"
            onClick={(e) => {
              e.preventDefault();
              navigate("/customer/dashboard");
            }}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <HomeIcon sx={{ mr: 0.5, fontSize: 20 }} />
            Customer Dashboard
          </Link>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            Total Orders
          </Typography>
        </Breadcrumbs>
        <Button
          size="small"
          variant="text"
          startIcon={<HelpOutlineIcon />}
          onClick={() => navigate("/customer/dashboard")}
          sx={{ textTransform: 'none', color: '#007185', fontWeight: 600 }}
        >
          Help & CS
        </Button>
      </Box>

      <Typography variant="h5" fontWeight={700} mb={3}>
        Total Orders
      </Typography>

      {orders.map((order) => (
        <Paper
          key={order._id}
          sx={{
            mb: 3,
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box sx={{ bgcolor: "#f3f3f3", p: 2 }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              spacing={1}
            >
              <Typography fontSize={14}>
                <b>ORDER PLACED</b><br />
                {new Date(order.createdAt).toLocaleDateString()}
              </Typography>

              <Typography fontSize={14}>
                <b>TOTAL</b><br />
                ₹{Number(order.total).toLocaleString("en-IN")}
              </Typography>

              <Typography fontSize={14}>
                <b>ORDER #</b><br />
                {order._id}
              </Typography>
            </Stack>
          </Box>

          {/* Body */}
          <Box sx={{ p: 2 }}>
            <Typography fontWeight={600} mb={1}>
              Status: {order.tracking?.at(-1)?.label}
            </Typography>

            <Divider sx={{ my: 1 }} />

            <Stack direction="row" spacing={2} alignItems="center">
              <Button
                size="small"
                variant="outlined"
                onClick={() =>
                  navigate(`/customer/orders/${order._id}`)
                }
              >
                View order details
              </Button>

              {order.tracking?.at(-1)?.label === "DELIVERED" && (
                <Button
                  size="small"
                  sx={{
                    textTransform: "none",
                    color: "#007185",
                    fontWeight: 600,
                  }}
                  onClick={() =>
                    openReviewDialog(
                      order.items[0].productId,
                      order._id
                    )
                  }
                >
                  Write / Edit Review
                </Button>
              )}
            </Stack>
          </Box>
        </Paper>
      ))}

      {reviewCtx && (
        <ReviewDialog
          open={openReview}
          onClose={() => setOpenReview(false)}
          productId={reviewCtx.productId}
          orderId={reviewCtx.orderId}
          mode={reviewCtx.mode}
          reviewId={reviewCtx.reviewId}
        />
      )}
    </Box>
  );
};

export default CustomerOrders;